var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "type_tab", attrs: { id: "projectInquiry" } },
    [
      _c(
        "ul",
        _vm._l(_vm.navTabData, function (type, index) {
          return _c(
            "li",
            {
              key: index,
              class: _vm.nowShowType == type.nameEn ? "checkedLi" : "",
              on: {
                click: function ($event) {
                  return _vm.tabCheckType(type.nameEn)
                },
              },
            },
            [_vm._v(_vm._s(type.name))]
          )
        }),
        0
      ),
      _c("p", { staticClass: "sendButtom", on: { click: _vm.sumitBox } }, [
        _vm._v("我已添加完所有所需项目"),
        _c("br"),
        _vm._v("保存并发送询单"),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }